const getters = {
  appVersion: state => state.app.appVersion
}

export default getters
